import {DesktopLoginOptions} from '../../../types';
export type EditorDialogDesktopLoginSaveCallback = (args: DesktopLoginOptions) => void;
export interface EditorDialogDesktopLoginState {
	display: boolean;
	on_accept: EditorDialogDesktopLoginSaveCallback | undefined;
}
export enum EditorDialogDesktopLoginMutation {
	SHOW = 'SHOW',
	HIDE = 'HIDE',
}

export interface EditorDialogDesktopLoginShowOptions {}
export interface EditorDialogDesktopLoginShowOptionsWithCallback extends EditorDialogDesktopLoginShowOptions {
	on_accept: EditorDialogDesktopLoginSaveCallback | undefined;
}

export const EditorDialogDesktopLoginStateModule = {
	namespaced: true,
	state(): EditorDialogDesktopLoginState {
		return {
			display: false,
			on_accept: undefined,
		};
	},

	mutations: {
		[EditorDialogDesktopLoginMutation.SHOW]: (
			state: EditorDialogDesktopLoginState,
			payload: EditorDialogDesktopLoginShowOptionsWithCallback
		) => {
			state.on_accept = payload.on_accept;
			state.display = true;
		},

		[EditorDialogDesktopLoginMutation.HIDE]: (state: EditorDialogDesktopLoginState) => {
			state.display = false;
			state.on_accept = undefined;
		},
	},
};
